import _ from 'lodash';

const transformAxiosPayloadMiddleware = () => next => action => {
  if (action.axios === true && _.get(action, 'payload.status')) {
    const axiosMeta = {
      ...action.payload,
    };
    delete axiosMeta.data;
    const newAction = {
      ...action,
      axiosMeta,
      meta: {
        ..._.get(action, 'meta'),
      },
      payload: _.get(action, 'payload.data'),
    };

    return next(newAction);
  }
  return next(action);
};

export default transformAxiosPayloadMiddleware;
